import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const DiamondIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m21.438 10.52-6.989-8.892A3.714 3.714 0 0 0 11.731.5a3.712 3.712 0 0 0-2.686 1.2l-6.953 8.82A3.64 3.64 0 0 0 1.5 12.5c.02.674.225 1.33.592 1.896l.073.084 6.94 8.892a3.64 3.64 0 0 0 2.66 1.128 3.713 3.713 0 0 0 2.733-1.2l6.94-8.82a3.577 3.577 0 0 0-.073-3.96h.073zm-1.899 2.568-6.855 8.664a1.35 1.35 0 0 1-1.717.084l-6.88-8.772a1.193 1.193 0 0 1-.169-.564c.002-.186.043-.37.121-.54l6.856-8.664a1.35 1.35 0 0 1 1.716-.084l6.808 8.736c.125.193.192.418.193.648-.008.17-.05.337-.121.492h.048z"
        fillRule="evenodd"
      />
    </svg>
  )
})
